/** 
*@author: Sirisha.M
*@Description : 
**/
import React, { useState, useEffect, useRef } from 'react';
import axios from 'axios';
import { connect } from 'react-redux';
import Highlighter from 'react-highlight-words';
import localStorage from '../../../utils/localStorage';
import StyledTable from '../../../commons/styles/table';
import { DrawerFooter } from '../../../commons/styles/layout';
import themeSettings from '../../../commons/styles/themeSettings.json';
import { API_MODULES, IPAddress, API_RUBUSMASTERS } from '../../../commons/api';
import { UpdateMasters, CreateMasters, getParametersFileDownloadName } from '../APICalls';
import {
  Form,
  Input,
  Select,
  message,
  Button,
  Drawer,
  Upload,
  Tabs
} from 'antd';
import {
  SearchOutlined,
  EditOutlined,
  UploadOutlined,
  DownloadOutlined,
  PlusOutlined
} from '@ant-design/icons';
import translation from '../Utils/translation';

const { Option } = Select;
const { TabPane } = Tabs;

const APIList = {
  CreateParameters: `${API_MODULES.ParametersCreate}`,
  UpdateParameters: `${API_MODULES.ParametersUpdate}`
};

const Parameter = (props) => {
  const [formObject, setFormObject] = useState({});
  const [list, setList] = useState([]);
  const [visibleParent, setVisibleParent] = useState(false);
  const [searchText, setSearchText] = useState('');
  const [searchedColumn, setSearchedColumn] = useState('');
  const [fileDownloadName, setFileDownloadName] = useState('');
  const [translationCache, setTranslationCache] = useState(props.translationCache || []);

  const hForm = useRef(null);

  useEffect(() => {
    _getList();
    getFileDownloadName();
  }, []);

  useEffect(() => {
    if (props.translationCache !== translationCache) {
      setTranslationCache(props.translationCache);
    }
    // Handle translation cache updates if needed
  }, [translationCache]);

  const _getList = () => {
    let path = '';
    if (props && props.type && props.type === 'deviceTypes') {
      path = window.location.pathname.split('/rubus/CustomerAssetDevice/DeviceTypesChildren/');
    } else {
      path = window.location.pathname.split('/rubus/CustomerAssetDevice/SubDeviceChildren/');
    }
    const siteId = localStorage.get('currentSite');
    const accessToken = localStorage.get('accessToken');
    let url = '';
    url = `${API_RUBUSMASTERS.ParametersGet}?SiteId=${siteId}&DeviceType=${path[1]}`;

    let orgHeaders = {
      method: 'GET',
      url,
      headers: {
        Authorization: `Bearer ${accessToken}`
      }
    };
    axios(orgHeaders)
      .then((response) => {
        setList(response.data);
      })
      .catch(function (error) {
        console.log(error);
      });
  };



  const _editRecord = (record) => {
    hForm.current && hForm.current.setFieldsValue(record);
    setVisibleParent(true);
    setFormObject(record);
  };

  const handleSearch = (selectedKeys, confirm, dataIndex) => {
    confirm();
    setSearchText(selectedKeys[0]);
    setSearchedColumn(dataIndex);
  };
  const handleReset = (clearFilters, confirm) => {
    clearFilters();
    handleSearch([], confirm);
  };
  let searchInput;
  const getColumnSearchProps = (dataIndex) => ({
    filterDropdown: ({ setSelectedKeys, selectedKeys, confirm, clearFilters }) => (
      <div style={{ padding: 8 }}>
        <Input
          ref={(node) => {
            searchInput = node;
          }}
          placeholder={`Search ${dataIndex}`}
          value={selectedKeys[0]}
          onChange={(e) => setSelectedKeys(e.target.value ? [e.target.value] : [])}
          onPressEnter={() => handleSearch(selectedKeys, confirm, dataIndex)}
          style={{ width: 188, marginBottom: 8, display: 'block' }}
        />

        <Button
          type="primary"
          onClick={() => handleSearch(selectedKeys, confirm)}
          icon={<SearchOutlined />}

          style={{ width: 90, marginRight: 8 }}
        >
          {translation(translationCache, 'Search')}
        </Button>
        <Button
          onClick={() => handleReset(clearFilters, confirm)}

          style={{ width: 90 }}
        >
          {translation(translationCache, 'Reset')}
        </Button>
      </div>
    ),
    filterIcon: (filtered) => (
      <SearchOutlined style={{ color: filtered ? '#1890ff' : undefined, }} />
    ),
    onFilter: (value, record) =>
      record[dataIndex].toString().toLowerCase().includes(value.toLowerCase()),
    onFilterDropdownOpenChange: (visible) => {
      if (visible) {
        setTimeout(() => searchInput.select());
      }
    },
    render: (text) =>
      searchedColumn === dataIndex ? (
        <Highlighter
          highlightStyle={{ backgroundColor: '#ffc069', padding: 0 }}
          searchWords={[searchText]}
          autoEscape
          textToHighlight={text.toString()}
        />
      ) : (
        text
      )
  });

  const OpenDrawer = () => {
    hForm.current &&
      hForm.current.setFieldsValue({
        DeviceType: null,
        Code: null,
        Name: null,
        Type: null,
        AliasCode: null,
        Category: null,
        DataType: null,
        UOM: null
      });
    let formObject = {
      DeviceType: null,
      Code: null,
      Name: null,
      Type: null,
      AliasCode: null,
      Category: null,
      DataType: null,
      UOM: null
    };
    setVisibleParent(true);
    setFormObject(formObject);
  };
  const onClose = () => {
    hForm.current &&
      hForm.current.setFieldsValue({
        DeviceType: null,
        Code: null,
        Name: null,
        AliasCode: null,
        Type: null,
        Category: null,
        DataType: null,
        UOM: null
      });
    setVisibleParent(false);
    setFormObject({});
  };

  const onFinish = async () => {
    let path = '';
    if (props && props.type && props.type === 'deviceTypes') {
      path = window.location.pathname.split('/rubus/CustomerAssetDevice/DeviceTypesChildren/');
    } else {
      path = window.location.pathname.split('/rubus/CustomerAssetDevice/SubDeviceChildren/');
    }

    hForm.current &&
      hForm.current
        .validateFields()
        .then(async (values) => {
          let payload = {
            ...values,
            DeviceType: path && Array.isArray(path) && path[1] ? path[1] : ''
          };

          if (formObject && formObject.Id) {
            let UpdateResponse = await UpdateMasters(
              APIList.UpdateParameters,
              payload,
              formObject.Id
            );
            if (UpdateResponse === undefined) {
              message.error("Not Acceptable");
            } else {
              message.success(UpdateResponse && UpdateResponse.message);
            }
          } else {
            let CreateResponse = await CreateMasters(APIList.CreateParameters, payload);
            CreateResponse && message.success(CreateResponse && CreateResponse.message);
          }
          _getList();
          getFileDownloadName();
          hForm.current &&
            hForm.current.setFieldsValue({
              DeviceType: null,
              Code: null,
              Name: null,
              AliasCode: null,
              Type: null,
              Category: null,
              DataType: null,
              UOM: null
            });
          setFormObject({});
          setVisibleParent(false);
        })
        .catch((error) => {
          console.log(error);
        });
  };
  const getFileDownloadName = async () => {
    let path = '';
    if (props && props.type && props.type === 'deviceTypes') {
      path = window.location.pathname.split('/rubus/CustomerAssetDevice/DeviceTypesChildren/');
    } else {
      path = window.location.pathname.split('/rubus/CustomerAssetDevice/SubDeviceChildren/');
    }
    let fileDownloadName = await getParametersFileDownloadName(path[1]);
    setFileDownloadName(fileDownloadName && fileDownloadName.file ? fileDownloadName.file : '');
  };

  const siteId = localStorage.get('currentSite');
  const token = localStorage.get('accessToken');
  var Authorization = 'Bearer ' + token;
  let path = '';
  if (props && props.type && props.type === 'deviceTypes') {
    path = window.location.pathname.split('/rubus/CustomerAssetDevice/DeviceTypesChildren/');
  } else {
    path = window.location.pathname.split('/rubus/CustomerAssetDevice/SubDeviceChildren/');
  }
  let colum = [
    { key: 'S No', value: 'S No' },
    { key: 'Parameter Code', value: 'Code' },
    { key: 'Parameter Name', value: 'Name' },
    { key: 'Type', value: 'Type' },
    { key: 'Category', value: 'Category' },
    { key: 'Data Type', value: 'DataType' },
    { key: 'UOM', value: 'UOM' }
  ];
  let columns =
    colum && Array.isArray(colum)
      ? colum
        .map((field) => {
          return {
            title: field.key,
            dataIndex: field.value,
            key: field.value,
            ...getColumnSearchProps(field.value)
          };
        })
      : [];

  let finalColumns = [
    ...columns,
    {
      title: translation(translationCache, 'Actions'),
      dataIndex: 'Actions',
      key: 'Actions',
      render: (_text, record) => (
        <span>
          <Button
            type='primary'
            icon={<EditOutlined />}
            onClick={() => _editRecord(record)}

          />
        </span>
      )
    }
  ];
  return (
    <>
      <div style={{ display: 'flex', justifyContent: 'right', marginTop: '10px' }}>
        <Button type='primary' style={{ marginRight: '10px' }}>
          <a href={`${IPAddress.LOCAL}${fileDownloadName}`}>
            <DownloadOutlined style={{ marginRight: '1px' }} />
            <span style={{ marginRight: '10px' }}>{translation(translationCache, 'Download')} </span>
          </a>
        </Button>
        <Button type='primary' style={{ marginRight: '10px' }}>
          <Upload
            multiple={false}
            style={{ marginRight: '10px', color: 'white' }}
            onChange={(info) => {
              if (info.file.status === 'done') {
                message.success(info.file.response.message);
                getFileDownloadName();
                _getList();
              } else if (info.file.status === 'error') {
                message.error(info.file.response.message);
              }
            }}
            action={`${API_RUBUSMASTERS.Upload_Parameters}?SiteId=${siteId}&DeviceTypeAlias=${path[1]}`}
            headers={{
              Authorization: Authorization
            }}
            showUploadList={false}
          >
            <UploadOutlined style={{ marginRight: '1px' }} />
            <span style={{ marginRight: '10px' }}> {translation(translationCache, 'Upload')} </span>
          </Upload>
        </Button>
        <Button onClick={OpenDrawer} style={{ marginRight: '10px' }}>
          <PlusOutlined /> {translation(translationCache, 'Add Parameter')}
        </Button>
      </div>

      <Tabs theme={themeSettings}>
        <TabPane>
          <StyledTable size="small"
            columns={finalColumns}
            dataSource={list}
            pagination={
              list.length > 10
                ? {
                  pageSize: '10'
                }
                : false
            }
          />
        </TabPane>
      </Tabs>

      <Drawer
        title={
          formObject && formObject.Id
            ? translation(translationCache, 'Update Parameter')
            : translation(translationCache, 'Add Parameter')
        }
        placement="right"
        width={600}
        closable
        onClose={onClose}
        open={visibleParent}
      >
        <Form
          labelCol={{ span: 6 }}
          wrapperCol={{ span: 12 }}
          theme={themeSettings}
          layout="horizontal"
          ref={hForm}
          name="ParameterSite_form"
          initialValues={formObject}
          onFinish={onFinish}
        >
          <Form.Item
            label={translation(translationCache, 'Code')}
            name="Code"
            rules={[{ required: true, message: translation(translationCache, 'Please enter Code !') }]}
          >
            <Input
              disabled={formObject && formObject.Id ? true : false}
              placeholder={translation(translationCache, 'Please enter Code ')}
            />
          </Form.Item>
          <Form.Item
            label={translation(translationCache, 'Name')}
            name="Name"
            rules={[{ required: true, message: translation(translationCache, 'Please enter Name !') }]}
          >
            <Input placeholder={translation(translationCache, 'Please enter Name')} />
          </Form.Item>
          <Form.Item
            label={translation(translationCache, 'Type')}
            name="Type"
            rules={[{ required: true, message: translation(translationCache, 'Please enter Type !') }]}
          >
            <Input placeholder={translation(translationCache, 'Please enter Type')} />
          </Form.Item>
          <Form.Item
            label={translation(translationCache, 'Category')}
            name="Category"
            rules={[{ required: true, message: translation(translationCache, 'Please select Category !') }]}
          >
            <Select placeholder={translation(translationCache, 'Select Category')}>
              <Option value="Operational">{'Operational'}</Option>
              <Option value="OnChange">{'OnChange'}</Option>
            </Select>
          </Form.Item>
          <Form.Item
            label={translation(translationCache, 'Data Type')}
            name="DataType"
            rules={[{ required: true, message: translation(translationCache, 'Please enter DataType !') }]}
          >
            <Input placeholder={translation(translationCache, 'Please enter Data Type')} />
          </Form.Item>
          <Form.Item
            label={translation(translationCache, 'UOM')}
            name="UOM"
            rules={[{ required: true, message: translation(translationCache, 'Please enter UOM !') }]}
          >
            <Input placeholder={translation(translationCache, 'Please enter UOM')} />
          </Form.Item>
          <DrawerFooter>
            <Button type="primary" onClick={onClose} style={{ marginRight: 8 }}>
              {translation(translationCache, 'Cancel')}
            </Button>
            <Button type="primary" onClick={onFinish}>
              {formObject && formObject.Id ? translation(translationCache, 'Update') : translation(translationCache, 'Submit')}
            </Button>
          </DrawerFooter>

        </Form>
      </Drawer>
    </>
  );
};

const mapStateToProps = (state) => ({
  translationCache: state.TranslationReducer.translationCache
});
export default connect(mapStateToProps)(Parameter);
